import { useState, useRef, useCallback, useEffect } from "react";
const useFieldHasContent = ({
  onChange,
  value
}) => {
  const [hasContent, setHasContent] = useState(!!(value != null && value.length)), changeHandlerRef = useRef(onChange);
  changeHandlerRef.current = onChange;
  const handleChange = useCallback((e) => {
    var _a;
    (_a = changeHandlerRef.current) == null || _a.call(changeHandlerRef, e), e.target.value.length ? setHasContent(!0) : setHasContent(!1);
  }, []);
  return useEffect(() => {
    value != null && value.length ? setHasContent(!0) : setHasContent(!1);
  }, [value]), {
    hasContent,
    setHasContent,
    handleChange
  };
};
export {
  useFieldHasContent
};
//# sourceMappingURL=useFieldHasContent.js.map
